import { Editor, Range, Transforms } from 'slate'

import { ALIGNABLE_TYPES } from './serialization'
import { formatHref } from '../../utils/link-sanitizer'
import { isExternalURL } from './links'
import { isQuote } from './toolbar/QuoteButton'

export function withButtons(editor) {
  const { normalizeNode } = editor

  editor.normalizeNode = (entry) => {
    const [node, path] = entry

    // Removing color marks from nodes
    if (isButton(node) && node.children.some((child) => child.color)) {
      const { selection } = editor

      Transforms.select(editor, path)
      Editor.removeMark(editor, 'color')

      Transforms.setSelection(editor, selection)
      return
    }

    normalizeNode(entry)
  }

  return editor
}

export function isButton(node) {
  return node.type === 'button'
}

export function getButton(editor) {
  const [match] = Editor.nodes(editor, { match: isButton })
  return match
}

export function isButtonFocused(editor) {
  if (!editor.selection) return false
  const [, focusedNodePath] = Editor.node(editor, Range.start(editor.selection))
  const [parent] = Editor.parent(editor, focusedNodePath)

  return isButton(parent)
}

export function isAnyButtonSelected(editor) {
  const nodes = Array.from(Editor.nodes(editor, { match: isButton }))

  return nodes.length > 0
}

export function unbutton(editor) {
  const [button, path] = getButton(editor)
  Transforms.setNodes(editor, { ...button, type: 'paragraph' }, { at: path })
  Transforms.select(editor, path)
}

export function insertButton(editor, href, text, isExternal) {
  const url = formatHref(href)
  const isCollapsed = editor.selection && Range.isCollapsed(editor.selection)
  const [alignableEntry] = Array.from(Editor.nodes(editor, { match: (n) => ALIGNABLE_TYPES.includes(n.type) }))

  const button = {
    type: 'button',
    url,
    children: isCollapsed ? [{ text: text || href }] : undefined,
    isExternal: isExternal !== undefined ? isExternal : isExternalURL(url),
  }

  if (alignableEntry) button.align = alignableEntry[0].align

  if (isCollapsed) {
    const isEmpty = editor.isEmptyLine(editor)
    const { selection } = editor

    if (isQuote(editor)) {
      Editor.insertNode(editor, button)
      if (isEmpty) Transforms.removeNodes(editor, { at: selection })
    } else if (isEmpty) {
      editor.apply({ type: 'insert_node', node: button, path: selection.focus.path })
      Transforms.unwrapNodes(editor, { mode: 'highest' })
    } else {
      Editor.insertBreak(editor)
      Editor.insertNode(editor, button)
    }
  } else {
    Transforms.setNodes(editor, button, { split: true })
  }
}
